// External libraries
import styled from '@emotion/styled';

const CardDetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;

  > div:nth-of-type(2n) {
    margin-left: 16px;
  }
`;

export { CardDetailsContainer };
